import { Box, Link, Typography } from "@mui/material";
import { CasLoader } from "../brand/CasLoader";
import { NoteBlockContainer, NotePageContainer } from "../note";
import { useAuth } from "../../hook/auth";
import { resetAgentProvider } from "../../hook/agentProvider";

export const RootPage: React.FC = () => {
  const { loginWithPopup, isLoading, isAuthenticated } = useAuth();

  if (isLoading || isAuthenticated) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingTop: 8,
          gap: 3,
        }}
      >
        <img
          src="/omega_logo_small.png"
          alt="OmegaAI"
          style={{ width: 64, height: 64, objectFit: "contain" }}
        />
        <CasLoader />
      </Box>
    );
  }

  return (
    <NotePageContainer pageName="Logged Out">
      <NoteBlockContainer name="Logged Out">
        <Typography>
          <Link
            onClick={() => {
              // A fresh sign-in must not reuse the previous account's cached provider row.
              resetAgentProvider();
              loginWithPopup();
            }}
          >
            Login
          </Link>{" "}
          to access OmegaAI.
        </Typography>
      </NoteBlockContainer>
    </NotePageContainer>
  );
};
